module.exports = __webpack_public_path__ + "static/media/cert_50.ab7f7296.jpg";